module.exports = __webpack_public_path__ + "img/card-bg-01.724c16b4.png";